import React from "react";
import { MainLayout } from "../../MainLayout";
import { TanzaniaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const Tanzania = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/tanzania-air.png",
            sliderimg: [
                { id: 1, img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/tanzania.webp", title: "Ngorongoro " },
                { id: 2, img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/tanzania2.webp", title: "Wildlife Safari" },
            ],
            title: "5N/6D Safari Tarangire, Serengeti and Ngorongoro Crater",
            days: "5N/6D",
            tags: ["Safari", "Sightseeing", "WildLife"],
            description: "This 6-day safari adventure takes you through Tanzania’s top wildlife destinations—Serengeti, Ngorongoro Crater, and Tarangire National Park. Enjoy thrilling game drives, witness the Big Five, and explore diverse landscapes, from vast savannas to the iconic baobab-dotted Tarangire. Stay in comfortable lodges or tented camps while traveling in a 4x4 safari vehicle with expert guides. The journey starts in Arusha and concludes with a return transfer after an unforgettable wildlife experience.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/trek.webp",
            slug: "safariTarangireSerengetiandNgorongoroCrater",
        },
        {
            title: "5N/6D Classic Lake Manyara, Serengeti & Ngorongoro Safari",
            days: "5N/6D",
            tags: ["Safari", "Lakes", "WildLife"],
            description: "This 6-day classic safari takes you through Tanzania’s most iconic wildlife destinations—Lake Manyara, Serengeti, and Ngorongoro Crater. Enjoy breathtaking landscapes, diverse wildlife, and incredible game drives, including opportunities to witness the Big Five and the Great Migration. Stay in comfortable lodges or tented camps while experiencing guided safaris in a 4x4 vehicle. The journey starts in Arusha and ends at Kilimanjaro International Airport, offering an amazing African adventure.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/trek.webp",
            slug: "classicLakeManyaraSerengetiandNgorongoroSafari",
        },
        {
            title: "5N/6D Lake Manyara, Tarangire, Ngorongoro Crater and Serengeti",
            days: "5N/6D ",
            tags: ["Safari", "Lakes", "WildLife"],
            description: "This 6-day safari takes you through Tanzania’s top wildlife destinations, including Lake Manyara, Serengeti, Ngorongoro Crater, and Tarangire. Experience diverse landscapes, from lush forests and endless plains to volcanic craters and baobab-dotted terrain, while spotting the Big Five and witnessing breathtaking wildlife encounters. Enjoy daily game drives, comfortable lodges, and expert-guided exploration for an unforgettable African adventure. The journey starts and ends in Arusha, offering a seamless and immersive safari experience.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/beacht.webp",
            slug: "lakeManyaraSerengetiNgorongoroCraterandTarangire"
        },
        {
            title: "2N/3D Serengeti National Park Safari",
            days: "2N/3D",
            tags: ["Bird Haven", "Lakes", "WildLife"],
            description: "This 3-day Serengeti safari takes you through Tanzania’s most iconic wildlife park, offering thrilling game drives across its vast plains. Starting from Arusha, you’ll journey through the Ngorongoro Conservation Area into the heart of Serengeti, where you’ll witness the Big Five and the famous wildebeest migration. Enjoy a full-day wildlife exploration in the Seronera region, known for its rich biodiversity and predator sightings. The adventure concludes with a scenic drive back to Arusha, leaving you with unforgettable memories of Africa’s wild beauty.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/north.webp",
            slug: "serengetiNationalParkSafari"
        },
        {
            title: "2N/3D Safari Ngorongoro Crater",
            days: "2N/3D",
            tags: ["Bird Haven", "Lakes", "WildLife"],
            description: "Descend into the breathtaking Ngorongoro Crater for a safari like no other, surrounded by dramatic landscapes and abundant wildlife. Encounter the Big Five in one of the world’s most unique and untouched natural habitats.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/crater.webp",
            slug: "safariNgorongoroCrater"
        },
        {
            title: "4N/5D Safari & Coastal Journey",
            days: "4N/5D",
            tags: ["Island", "Lakes", "Beach"],
            description: "Relax, explore, and unwind in Zanzibar on this 5-day tropical escape. From visiting historic Prison Island and snorkeling at Mnemba Atoll to optional sandbank adventures, the trip blends culture, nature, and leisure by the Indian Ocean. A perfect mix of beach bliss and memorable tours.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/top-tanz-4.webp",
            slug: "zanziBar1"
        },
        {
            title: "3N/4D Luxury in the Spice Isles",
            days: "3N/4D",
            tags: ["Island", "Lakes", "Beach"],
            description: "Indulge in the exotic charm in Zanzibar on this 4-day pristine beaches and crystal-clear waters. Experience world-class luxury resorts, private dhow cruises, and personalized spa retreats.Discover the rich spice heritage and vibrant culture of the Spice Isles in absolute elegance.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/zanzibar.webp",
            slug: "zanziBar2"
        },
    ];

    const topcitydata = [
        {
            id: 1, title: "Dar es Salaam", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Dar%20es%20salam.webp", desc: [
                <p><strong>Why Visit: </strong>Dar es Salaam is Tanzania's largest city and a major port on the Indian Ocean. It’s a bustling metropolis, known for its blend of modern and traditional influences, offering vibrant markets, beautiful beaches, and historical sites.</p>,
                <p><strong>Top Attractions: </strong>National Museum, Village Museum, Kivukoni Fish Market, Coco Beach, and nearby Zanzibar (accessible via ferry or flight).</p>
            ]
        },
        {
            id: 2, title: "Arusha", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Arusha%20Tanzania.webp", desc: [
                <p><strong>Why Visit: </strong>Arusha is often called the "Safari Capital" of Tanzania because it is the gateway to some of the country's most famous national parks, including Serengeti National Park and Ngorongoro Crater. It’s also a city rich in culture and surrounded by beautiful landscapes.</p>,
                <p><strong>Top Attractions: </strong>Arusha National Park, Mount Meru, Cultural Heritage Centre, Ngorongoro Crater, and the nearby Serengeti.</p>
            ]
        },
        {
            id: 3, title: "Zanzibar City (Stone Town)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Tanzania%20Top%20Places/Tanzania%20Top%20Places/Stone%20town%20Zanzibar.webp", desc: [
                <p><strong>Why Visit: </strong>The capital of the Zanzibar Archipelago, Stone Town is a UNESCO World Heritage Site with a fascinating blend of Swahili, Arab, Indian, and European influences. The city’s winding alleys, historical buildings, and vibrant markets offer an incredible cultural experience.</p>,
                <p><strong>Top Attractions: </strong>Stone Town, House of Wonders, Forodhani Gardens, Spice Farms, Jozani Forest, and Nungwi Beach.</p>
            ]
        },
        {
            id: 4, title: "Dodoma", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Dodoma%20Tanzania.webp", desc: [
                <p><strong>Why Visit: </strong>Dodoma is Tanzania’s political capital, located in the central part of the country. It’s a smaller city compared to Dar es Salaam but offers a quieter atmosphere. The city is rich in history and surrounded by beautiful natural landscapes.</p>,
                <p><strong>Top Attractions: </strong>Chadema Party Headquarters, Dodoma Cathedral, and the Gaddafi Mosque.</p>
            ]
        },
        {
            id: 5, title: "Moshi", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Tanzania%20Top%20Places%201/Tanzania%20Top%20Places/Moshi.webp", desc: [
                <p><strong>Why Visit: </strong>Moshi is a popular town at the base of Mount Kilimanjaro, the highest peak in Africa. It’s known as a base for climbers aiming to summit Kilimanjaro and for its welcoming atmosphere and cool highland climate.</p>,
                <p><strong>Top Attractions: </strong>Mount Kilimanjaro National Park, Materuni Waterfalls, Kilimanjaro Coffee Farms, and Moshi Town.</p>
            ]
        },
        {
            id: 6, title: "Mbeya", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Tanzania%20Top%20Places%201/Tanzania%20Top%20Places/Mbeya.webp", desc: [
                <p><strong>Why Visit: </strong>Located in the southwestern part of Tanzania, Mbeya is known for its picturesque landscapes, lush vegetation, and coffee plantations. It’s also the gateway to the Ruinsori Mountains and Kitulo National Park.</p>,
                <p><strong>Top Attractions: </strong>Mbeya Regional Museum, Sangabuye Falls, and the Ruhuhu River.</p>
            ]
        },
        {
            id: 7, title: "Tanga", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Tanga%20Tanzania.webp", desc: [
                <p><strong>Why Visit: </strong>Tanga is a coastal city with historical significance, offering a quiet atmosphere with beautiful beaches, historical sites, and proximity to Saadani National Park and the Usambara Mountains.</p>,
                <p><strong>Top Attractions: </strong>Amboni Caves, Tanga Beach, and Mkinga for scenic views and cultural experiences.</p>
            ]
        },
        {
            id: 8, title: "Bagamoyo", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Tanzania%20Top%20Places%201/Tanzania%20Top%20Places/Bagamoya.webp", desc: [
                <p><strong>Why Visit: </strong>Bagamoyo is an important historical town on the Tanzanian coast, once a trading port and a center for the East African slave trade. The town offers a glimpse into Tanzania's colonial history and its natural beauty.</p>,
                <p><strong>Top Attractions: </strong>Bagamoyo Old Town, Caravan Serai, Old Fort, and Bagamoyo Beach.</p>
            ]
        },
        {
            id: 9, title: "Iringa", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Iringa%20Tanzania.webp", desc: [
                <p><strong>Why Visit: </strong>Iringa is located in the southern highlands of Tanzania and is known for its cool climate, coffee plantations, and proximity to Ruinsori Mountains National Park and Ruinsori Hills. It’s a gateway to southern Tanzania’s parks and the Selous Game Reserve.</p>,
                <p><strong>Top Attractions: </strong>Ruinsori Mountains, Iringa Museum, Isimila Stone Age Site, and local craft markets.</p>
            ]
        },
        {
            id: 10, title: "Mtwara", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Tanzania%20Top%20Places%201/Tanzania%20Top%20Places/Mtwara.webp", desc: [
                <p><strong>Why Visit: </strong>Mtwara is a port city in the south of Tanzania, known for its tropical climate, beautiful beaches, and cultural sites. It offers a more off-the-beaten-path experience compared to the country’s more famous tourist destinations.</p>,
                <p><strong>Top Attractions: </strong>Mtwara Beach, Mtwara Ruins, and Lindi Port.</p>
            ]
        }
    ]
    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Safari-Led Itinerary Design",
            desc: "Build high-demand programs around the Great Migration in Serengeti National Park, combined with year-round wildlife viewing in the Ngorongoro Crater."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Wildlife Safari Experiences",
            desc: "Offer guided game drives with opportunities to witness the Big Five and the Great Migration, maximizing sightings across different seasons."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Lodge & Camp Stays",
            desc: "Choose from a wide range of safari lodges and tented camps across key regions. Available for different budgets while maintaining comfort and quality."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Zanzibar Beach Extensions",
            desc: "Combine inland safaris with relaxing stays in the Zanzibar Archipelago. This creates a well-balanced bush-and-beach travel experience for your clients."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Mt. Kilimanjaro Treks",
            desc: "Support trekking programs to Mt. Kilimanjaro with guided routes and proper planning. Suitable options are available for both experienced and first-time trekkers."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Cultural Experiences",
            desc: "Add local village visits and cultural interactions to enrich the overall journey. These experiences offer insight into Tanzania’s traditions and way of life."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Private Safari Transport",
            desc: "Provide reliable 4x4 safari vehicles with experienced driver-guides. Travel between parks is managed smoothly to ensure comfort and efficiency."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "On-Ground Support",
            desc: "Ensure consistent coordination with trusted local teams throughout the journey. Every detail is managed to deliver a seamless travel experience."
        },
    ];
    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Tanzaniaaa.webp")'}
                text2={"Tanzania"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={TanzaniaSec1Data} />
            <IndiaSec2 countryCode="TZ" />
            <IndiaSec3 data={topcitydata} name={"Tanzania"} />
            <IndiaSec4 data={data}
                heading={"Tanzania Travel Solutions We Deliver "}
            />
            <Footer />

        </>
    )


};